import chroma from 'chroma-js';

type Mode = 'light' | 'dark';
type Theme = 'theme-1' | 'theme-2' | 'theme-3';

const toRgbString = (color: string) => {
  return chroma(color).rgb().join(', '); // превратит #000 в "0, 0, 0"
};

export const generatePalette = (color: string, mode: Mode, themeType: Theme) => {
  if (!chroma.valid(color)) return null;

  const base = chroma(color);
  const isDark = mode === 'dark';

  const colors = {
    main: base.hex(),
    secondary: '',
    accent: '',
    text: isDark ? '#fffffff2' : '#262626',
    background: '',
    section: '',
    shadow: '',
  };

  if (!isDark) {
    // --- LIGHT MODE ---
    colors.background = '#f6f6f6';
    colors.section = '#ffffff';
    colors.shadow = base.alpha(0.15).css();

    if (themeType === 'theme-1') {
      colors.secondary = base.luminance(0.95).hex();
      colors.accent = base.darken(1.5).hex();
    } else if (themeType === 'theme-2') {
      colors.secondary = base.set('hsl.h', '+10').darken(1.2).hex();
      colors.accent = base.darken(2.5).hex();
      colors.background = '#ffffff';
      colors.section = '#f7f7f7';
    } else if (themeType === 'theme-3') {
      colors.secondary = base.luminance(0.92).desaturate(0.5).hex();
      colors.accent = base.darken(2).hex();
    }
  } else {
    // --- DARK MODE ---
    colors.background = '#232332';
    colors.section = '#2c2c3f';
    colors.shadow = '#00000040';

    if (themeType === 'theme-1') {
      colors.secondary = base.alpha(0.3).css();
      colors.accent = base.brighten(1).hex();
    } else if (themeType === 'theme-2') {
      colors.secondary = base.brighten(1.5).hex();
      colors.main = base.darken(1).hex();
      colors.accent = base.brighten(0.5).hex();
    } else if (themeType === 'theme-3') {
      colors.secondary = base.luminance(0.8).hex();
      colors.accent = base.brighten(1.5).hex();
    }
  }

  return {
    '--main-color': toRgbString(colors.main),
    '--secondary-color': toRgbString(colors.secondary),
    '--accent-color': toRgbString(colors.accent),
    '--text-color': toRgbString(colors.text),
    '--background-color': toRgbString(colors.background),
    '--section-color': toRgbString(colors.section),
    '--shadow-color': toRgbString(colors.shadow),
    '--button-hover-color': toRgbString(isDark 
    ? base.brighten(0.5).saturate(0.2).hex() 
    : base.darken(0.2).hex())
  };
};
